import React from "react";
import "./style.css";
import useThemeColors from "src/hooks/useThemeColors";

interface LoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  color?: "primary" | "success" | "warning" | "info";
}

const Loader: React.FC<LoaderProps> = ({ size = "md", color = "primary" }) => {
  const colors = useThemeColors();
  const sizeMap = {
    sm: "20px",
    md: "24px",
    lg: "32px",
    xl: "40px",
  };
  const borderWidthMap = {
    sm: "2px",
    md: "3px",
    lg: "4px",
    xl: "5px",
  };
  const heightMap = {
    sm: "20px",
    md: "24px",
    lg: "32px",
    xl: "40px",
  };
  const colorMap = {
    primary: colors["--app-primary"],
    success: colors["--status-success"],
    warning: colors["--status-warning"],
    info: colors["--app-info"],
  };
  return (
    <div
      className={`loader ${size}`}
      style={{
        width: sizeMap[size],
        height: heightMap[size],
        borderWidth: borderWidthMap[size],
        borderColor: colorMap[color],
      }}
    ></div>
  );
};

export default Loader;
